var Events = require('@alife/alpha-events/events');

// 同构时避免内存溢出，不使用全局绑定
if (window.__server__) {
    var noop = function(){};
    window.__eventManager = {
        on: noop,
        once: noop,
        attach: noop,
        detach: noop,
        emit: noop,
        notify: noop,
        off: noop,
        trigger: noop,
    };
}

if(!window.__eventManager){
    window.__eventManager = new Events();
}

module.exports = window.__eventManager;
